import { render, staticRenderFns } from "./InventoryActivity.vue?vue&type=template&id=6ac6b714"
import script from "./InventoryActivity.vue?vue&type=script&lang=js"
export * from "./InventoryActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports